import React, { Component, PropTypes } from 'react';
import { Field, reduxForm, getFormSyncErrors } from 'redux-form';
import axios from 'axios';
import {useSelector, connect} from 'react-redux';
import { CButton, CLabel } from 'compat/coreui';

const required = (value) => (value ? undefined : "Required");
const businessEmail = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Invalid email address"
    : undefined;
const businessName = (value) => 
  value === ""
    ? "User name required"
    : undefined;
const phone = min =>(value) => 
  value && value.length > min ? `Must be ${min} characters or more` : undefined;
const max1 = phone(10);

const num = (value) => value && isNaN(Number(value)) ? 'Must be a number' : undefined

const renderField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <div>
      <input {...input} placeholder={label} type={type} className="error-input socialbtn"/>
      <span className="text-red" style={{display: 'block', height: '20px'}}>{(touched && error) ? error: ''}</span>
  </div>
)
const renderSelectField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <div>
      <select {...input} type={type} className="error-input socialbtn step-select">
        <option value="">Select </option>
        <option value="dispensary">Dispensary</option>
        <option value="delivery service">Delivery Service</option>
        <option value="doctor">Doctor</option>
        <option value="smoke shop">Shop</option>
        <option value="send bank">Seed Bank</option>
      </select>
      <span className="text-red" style={{display: 'block', height: '20px'}}>{(touched && error) ? error: ''}</span>
  </div>
)

const StepOne = (props) => {
  console.log(props)
  const { handleSubmit, reset, setPage } = props;
  const values = useSelector(state => state.form.sellerForm && state.form.sellerForm.values);
  const validate = (e) =>{
    e.preventDefault()
    if (!props.valid) {
      props.touch("businesEmail");
      props.touch("businessName");
      props.touch("businessType");
      props.touch("phone");
      props.touch("webUrl");
    } else {
      setPage(2)
    }
  }

        return (
            <React.Fragment>
                <div className="step_wrap"> 
                <div className="col-md-8 col-sm-12">
                    <h2>Please fill in your information</h2>
                    <form className="form-container" onSubmit={handleSubmit} encType="multipart/form-data">
                      <div className="form-group">
                        <div className="col-md-6">
                            <label htmlFor="businessName">Business Name</label>
                            <Field component={renderField} name="businessName" validate={[required, businessName]} type="text" className="form-control" placeholder="Your Business Name" />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="businessEmail">Business Email</label>
                            <Field component={renderField} name="businessEmail" validate={[required, businessEmail]} type="email" className="form-control" id="businessEmail" aria-describedby="emailHelp" placeholder="youremail@domain.com" />
                        </div>
                      </div>
                      <div className="form-group">
                          <div className="col-md-6">
                            <label htmlFor="businessEmail">Phone</label>
                            <Field component={renderField} name="phone" validate={[required]} type="text" className="form-control" id="businessEmail" aria-describedby="emailHelp" placeholder="9999999999" />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="website">Website</label>
                            <Field component={renderField} name="webUrl" validate={[required]} type="text" className="form-control" placeholder="www.example.com"/>
                          </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-md-6" style={{paddingLeft: "28px"}}>
                          <CLabel htmlFor="Business Type" style={{height: 'auto'}}>Business Type</CLabel><br/>
                            <Field  component={renderSelectField} type="select" className="btype" name="businessType" validate={[required]} />
                         </div>
                      </div>
                      <CButton  color="info" type="submit" onClick={(e) => {validate(e)}}>Next</CButton>
                    </form>
                </div>
                <div className="col-md-3 hideCol">
                    <h5>General Information</h5>
                    <hr/>
                    <p style={{fontSize: '15px'}}>Please fill out some basic information on your business and we'll see if we can find any matching business information to help you complete the registration process more repidly.</p>
                    <div className="d-flex justify-content-between">
                      <CButton color="success">Continue</CButton>
                      <CButton color="warning" variant= 'outline' className="pl-5 pr-5">Back</CButton>
                    </div>
                </div>
                </div>
            </React.Fragment>
        );
}

let MainReduxForm = reduxForm({form: 'sellerForm', destroyOnUnmount: false})(StepOne)

export default MainReduxForm = connect((state) => ({
  synchronousError: getFormSyncErrors("sellerForm")(state),
}))(MainReduxForm);